/* Pulzena variant picker — auto-adjust option 2+ quand option 1 change.
   MAJ 21/04 : remplace le selector `[value="X"]` par une itération sur form.elements
   car CSS.escape() casse sur les values avec espaces (ex "Silicone Blanc"). */
(function() {
  function getVariants(picker) {
    const el = picker.querySelector('script[data-all-variants]');
    if (el) {
      try { return JSON.parse(el.textContent || '[]'); }
      catch(e) { console.warn('[pz-auto-adjust] JSON parse failed', e); return []; }
    }
    const handle = picker.getAttribute('handle');
    if (!handle) return [];
    return fetch(`/products/${encodeURIComponent(handle)}.js`, { credentials: 'same-origin' })
      .then(r => r.ok ? r.json() : {variants:[]})
      .then(d => d.variants || [])
      .catch(() => []);
  }

  function findInputByValue(form, position, value) {
    // Itération — safe pour values avec espaces/caractères spéciaux
    return Array.from(form.elements).find(el =>
      el.tagName === 'INPUT' &&
      el.type === 'radio' &&
      el.dataset.optionPosition === String(position) &&
      el.value === value
    );
  }

  async function attachTo(picker) {
    if (picker.dataset.pzAutoAdjust) return;
    picker.dataset.pzAutoAdjust = '1';
    let variants = getVariants(picker);
    if (variants instanceof Promise) variants = await variants;
    if (!variants || variants.length === 0) {
      console.warn('[pz-auto-adjust] no variants for', picker.getAttribute('handle'));
      return;
    }
    const formId = picker.getAttribute('form-id');
    const form = document.forms[formId];
    if (!form) { console.warn('[pz-auto-adjust] no form'); return; }

    const getOptions = () => {
      const maxPos = Math.max(1, ...variants.map(v => (v.option3 ? 3 : v.option2 ? 2 : 1)));
      const out = [];
      for (let p = 1; p <= maxPos; p++) {
        const el = Array.from(form.elements).find(x => x.tagName==='INPUT' && x.type==='radio' && x.dataset.optionPosition===String(p) && x.checked);
        out.push(el ? el.value : null);
      }
      return out;
    };

    const findVariant = (opts) => variants.find(v => {
      if (v.option1 !== opts[0]) return false;
      if (opts[1] != null && v.option2 !== opts[1]) return false;
      if (opts[2] != null && v.option3 !== opts[2]) return false;
      return true;
    });

    form.addEventListener('change', (e) => {
      const target = e.target;
      if (!target || target.tagName !== 'INPUT' || !target.dataset.optionPosition) return;
      const pos = parseInt(target.dataset.optionPosition, 10);
      if (pos !== 1) return;

      const opts = getOptions();
      if (findVariant(opts)) {
        return;
      }
      const validVariant = variants.find(v => v.option1 === opts[0] && v.available !== false);
      if (!validVariant) {
        console.warn('[pz-auto-adjust] no valid variant for', opts[0]);
        return;
      }
      for (let p = 2; p <= opts.length; p++) {
        const desiredVal = validVariant[`option${p}`];
        if (!desiredVal) continue;
        const input = findInputByValue(form, p, desiredVal);
        if (!input) { console.warn(`[pz-auto-adjust] no input for option${p}="${desiredVal}"`); continue; }
        if (!input.checked) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }, true);
  }

  function init() { document.querySelectorAll('variant-picker').forEach(attachTo); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  new MutationObserver(muts => muts.forEach(m => m.addedNodes.forEach(n => {
    if (n.nodeType === 1) {
      if (n.tagName === 'VARIANT-PICKER') attachTo(n);
      else n.querySelectorAll?.('variant-picker').forEach(attachTo);
    }
  }))).observe(document.body, { childList: true, subtree: true });
})();
